import { useState, useEffect } from 'react';
import { get, isEmpty } from 'lodash-es';

export const useFieldsControl = ({
  financingFields,
  setFormData,
  enableNextBtn,
  isBackState,
  prefillFromStorage, // TODO: Remove when shop-4713-prequal2 test is cleaned up
  getFinancingContainerFields,
  isJoint,
  step,
}) => {
  const [predefinedFields, setPredefinedFields] = useState(financingFields);
  const [isPrimaryFormValid, setIsPrimaryFormValid] = useState(false);
  const [isCoborrowerFormValid, setIsCoborrowerFormValid] = useState(false);
  const [isFormReady, setIsFormReady] = useState(false);

  const [formFields, setFormFields] = useState({});
  useEffect(
    () => {
      async function getFinancingFields() {
        const fieldsData = (await getFinancingContainerFields()) || {};
        const fields = get(fieldsData, `financingFields.${step}`, {});
        const isValid = !isEmpty(fields);

        setPredefinedFields(fields);
        setFormFields(fields);
        setFormData(fields);
        setIsPrimaryFormValid(isValid);
        setIsCoborrowerFormValid(isJoint && isValid);
        enableNextBtn(isValid);
        setIsFormReady(isValid);
      }
      // TODO: Remove prefillFromStorage condition when shop-4713-prequal2 test is cleaned up
      if ((isBackState || prefillFromStorage) && isEmpty(predefinedFields)) {
        getFinancingFields();
      }
    }, // eslint-disable-next-line
    [isBackState, prefillFromStorage, predefinedFields]
  );
  return {
    predefinedFields,
    formFields,
    isPrimaryFormValid,
    isCoborrowerFormValid,
    isFormReady,
    setIsFormReady,
    setFormFields,
    setIsPrimaryFormValid,
    setIsCoborrowerFormValid,
  };
};
